import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import ProductList from './components/ProductList.jsx';
import ProductGrid from './components/ProductGrid.jsx';
import browserHistory from '../../../appState/browserHistory';
import { getCurrentFiltersSetup, getCurrentUCMS } from './helpers';

export default function initProductListing() {
  const mountEl = document.querySelector('[data-component="product-list-view"]');
  if (!mountEl) {
    return;
  }

  // Set current filters state into history list so we can properly load products when
  // navigating back in history to this initial page.
  browserHistory.replaceState({
    type: browserHistory.actionTypes.LISTING_PAGE_FILTERS,
    payload: getCurrentFiltersSetup()
  }, getCurrentUCMS().segment);

  // React product listing is rendered after user clicks on some page in paginator
  // Until clicking on paginator, there are products rendered by server on page because of SEO.
  const unsubscribe = window.appState.subscribe(() => {
    const shouldRender = window.appState.getState().listingPage.pageSetup.renderReactProductList;
    if (shouldRender) {
      const activeView = window.appState.getState().listingPage.pageSetup.viewSwitch;

      if (activeView === 'grid') {
        ReactDOM.render(
          <Provider store={window.appState}>
            <ProductGrid />
          </Provider>,
          mountEl
        );
      } else {
        ReactDOM.render(
          <Provider store={window.appState}>
            <ProductList />
          </Provider>,
          mountEl
        );
      }

      if (unsubscribe) {
        unsubscribe();
      }
    }
  });
}
